import React from 'react';
import './RoomRow.css'

const RoomRow = (props) => {
    return ( 
        <div className='RoomRow'>
            <p className='RoomName'>{props.RoomName}</p>
            <p className='RoomValue'>{props.RoomValue}</p>
        </div>
     );
}
 
export default RoomRow;